<template>
  <div class="newsDetail">
    <!-- {{detaLi}} -->
 
	<div class="listCar">
			<div class="car-tet">
				<p>{{detaLi.title}}</p>
			</div>
			
	<!-- 头像。名称。时间 -->
			<div class="car-heat"> 
				<span>{{detaLi.author}}</span>
				<span>{{detaLi.add_time}}</span>
			</div>
		<!-- banner广告图 -->
			<div class="car-banner">
				<div class="car-ban-img" v-for="i in detaLi.image_input">
					<img :src=i alt="">
				</div>
			</div>
		<!-- 公司级介绍 -->
			<div class="list-tp" v-html="detaLi.content">
				<p>
					{{detaLi.content}}
				</p>
			</div>
		</div>
 
 
 
 
  </div>
</template>
<style scoped> 
	.car-hear{
		height: 50px;
		border-bottom: 1px solid cadetblue;
	}
	.car-hear div{
		line-height:50px ;
	}
	.car-tet{
		width: 100%;
		line-height: 50px;
		font-size: 20px;
		font-weight: bold;
		height: auto;
		padding: 0 20px;
	}
	.car-heat{
		width: 100%;
		height: 50px;
		color: #ccc;
		padding: 0 20px;
	}
	.car-heat span{
		margin: 0 15px;
	}
	.car-banner{
		width: 100%;
		/* height: 4rem; */
		background-color: #fff;
	}
	.car-ban-img{
		height: 100%;
		width: 90%;
		margin: 0 auto;
	}
	.car-ban-img img{
		width: 100%;
		height: 100%;
	}
	.list-tp{
		width: 100%;
		padding:0 20px;
		font-size: 18px;
	} 
	.list-tp p{
		width: 100%;
		height: 100%;
	}
</style>
<script>
import { getArticleDetails } from "@api/public";
import ShareInfo from "@components/ShareInfo";
import { isWeixin } from "@utils/index";
import { openShareAll } from "@libs/wechat";

export default {
  name: "NewsDetail",
  components: { ShareInfo },
  props: {},
  data: function() {
    return {
     detaLi:''
    };
  },
  watch: {
    $route(to) {
      this.articleDetails();
    }
  },
  mounted: function() {
    this.articleDetails();
  },
  methods: {
    updateTitle() {
      document.title = this.articleInfo.title || this.$route.meta.title;
    },
    articleDetails: function() {
      getArticleDetails({id:this.$route.query.id}).then(res => {
		  this.detaLi = res.data
	  });
    },
    // setShareInfoStatus: function() {
    //   this.shareInfoStatus = !this.shareInfoStatus;
    // },
    // share: function() {
    //   openShareAll({
    //     desc: this.articleInfo.synopsis,
    //     title: this.articleInfo.title,
    //     link: location.href,
    //     imgUrl: this.articleInfo.image_input.length
    //       ? this.articleInfo.image_input[0]
    //       : ""
    //   });
    // }
  }
};
</script>
